<template>
    <div>
        <el-row :gutter="12">
            <el-col :span="24">
                <register-form />
            </el-col>
        </el-row>
    </div>
</template>

<script>
import registerForm from './form/registerManager';

export default {
    name: 'Login',
    components: {
        registerForm
    }
};
</script>

